module.exports = __webpack_public_path__ + "img/header.5d5df8ca.jpg";